export default "__VITE_ASSET__COEomFRB__"